import { password } from "@/@core/utils/validations/validations";

export default {
  AddFix: 'แจ้งซ่อม',
  searchorder: 'ค้นหาหมายเลขซ่อม',
  placeholderOrderFix: 'หมายเลขการซ่อม',
  searchworkerid: 'ค้นหาหมายเลขพนักงาน',
  workerid: 'รหัสพนักงาน',
  searchUser: 'ค้นหาผู้ใช้',
  user: 'ชื่อผู้ใช้',
  email: 'อีเมล์',
  password: 'รหัสผ่าน',
  phone: 'เบอร์โทร',
  jobtitle: 'ตำแหน่ง',
  searchEmail: 'ค้นหาตามอีเมล',
  emailname: 'ชื่ออีเมล',
  searchdept: 'ค้นหาตามชื่อแผนก',
  deptname: 'ชื่อแผนก',
  searchrole: 'ค้นหาตามสิทธิ์ผู้ใช้',
  role: 'สิทธิ์ผู้ใช้',
  uppersearchrole: 'ตัวพิมพ์ใหญ่ทั้งหมด(USER)',
  startDate: 'เลือกวันเริ่มต้น',
  endDate: 'เลือกวันสิ้นสุด',
  search: 'ค้นหา',
  WaitImprove: 'รออนุมัติ',
  fixstatus: 'แจ้งซ่อม',
  fixing: 'ดำเนินการซ่อม',
  claim: 'ส่งเคลม/ส่งซ่อม',
  confirmjob: 'รอตรวจสอบ',
  cancelSucc: 'ยกเลิก/สำเร็จ',
  nofix: 'ไม่มีรายการซ่อม',
  allfixjob: 'แจ้งซ่อมทั้งหมด',
  showfixjob: 'แสดงงานซ่อม',
  returnfixjob: 'คืนงานซ่อม',

  deviceedit: 'จัดการอุปกรณ์',
  fixedit: 'จัดการการซ่อม',
  allimprove: 'อนุมัติทั้งหมด',
  fixcancel: 'ยกเลิกการซ่อม',
  fixcancelDetails: 'หมายเหตุในการยกเลิก',
  fixcancelDetailsinput: 'กรอกรายละเอียดหมายเหตุในการยกเลิก',
  cancelconfirm: 'ยืนยันการยกเลิก',
  cancel: 'ยกเลิก',
  rate: 'แบบประเมิณ',
  ratescore: 'คะแนน( 1 = น้อยที่สุด, 5 = มากที่สุด)',
  comment: 'ความคิดเห็น',
  commentInput: 'กรอกความคิดเห็น',
  sendcomment: 'ส่งแบบประเมิน',
  thankForhelp: 'ขอบคุณที่ให้ความร่วมมือ',
  thankForhelpText: 'ขอบคุณที่ให้ความร่วมมือในการประเมิน!',
  close: 'ปิด',
  loading: 'กำลังโหลดข้อมูล...',
  getfixjob: 'วันที่รับเรื่อง',
  files: 'ไฟล์เอกสาร',
  filesdone: 'ไฟล์เอกสาร(หลังซ่อม)',
  nofiles: 'ไม่มีไฟล์เอกสาร',

  // table
  fixDate: 'วันที่แจ้งซ่อม',
  cate: 'หมวดหมู่',
  subcate: 'หมวดหมู่ย่อย',
  device: 'อุปกรณ์',
  fixDetails: 'รายละเอียดแจ้งซ่อม',
  problem: 'สาเหตุ/ปัญหา',
  operator: 'ช่างซ่อมภายนอก',
  operatorinput: 'กรอกช่างซ่อมภายนอก',
  status: 'สถานะ',
  management: 'การจัดการ',
  worker: 'ผู้ดำเนินการซ่อม',

  // form
  fixinfo: 'ข้อมูลการซ่อม',
  typefix: 'ประเภทงานซ่อม',
  subcatefix: 'หมวดหมู่ย่อยงานซ่อม',
  deviceinfo: 'ข้อมูลอุปกรณ์',
  devicecate: 'หมวดหมู่อุปกรณ์หลัก',
  devicesubcate: 'หมวดหมู่ย่อยอุปกรณ์',
  fixinfodetails: 'ข้อมูลรายละเอียดการซ่อม',
  fixdetailstitle: 'รายละเอียดการซ่อม',
  problemdetails: 'กรอกรายละเอียดปัญหา',
  problemdetailsinput: 'กรอกรายละเอียดปัญหา',
  text150: 'กรุณากรอกข้อความไม่เกิน 150 ตัวอักษร',
  text100: 'กรุณากรอกข้อความไม่เกิน 100 ตัวอักษร',
  text50: 'กรุณากรอกข้อความไม่เกิน 50 ตัวอักษร',
  text30: 'กรุณากรอกข้อความไม่เกิน 30 ตัวอักษร',
  image: 'รูปภาพ',
  imageinfo: 'ข้อมูลภาพถ่าย/ไฟล์เอกสาร',
  addimage: 'เพิ่มรูปภาพ/ไฟล์เอกสาร',
  addimagefix: 'เพิ่มรูปภาพหลังซ่อม/ไฟล์เอกสาร',
  submit: 'บันทึก',
  notification: 'แจ้งเตือน',
  confirm: 'ยืนยัน',
  noticdetailsfix: 'กรุณากรอกรายละเอียดการซ่อมให้ถูกต้อง',
  text: 'ตัวอักษร',
  selectimage: 'เลือกไฟล์รูปภาพ/ไฟล์เอกสาร',
  notfoundsubcate: 'ไม่พบหมวดหมู่ย่อย',
  warning: 'คำเตือน',
  error: 'ข้อผิดพลาด',
  getsubcatefailed: 'ไม่สามารถดึงข้อมูลหมวดหมู่ย่อยได้',
  notfoundsubcateIndevice: 'ไม่พบข้อมูลอุปกรณ์ในหมวดหมู่ย่อยนี้',
  getdevicefailed: 'ไม่สามารถดึงข้อมูลอุปกรณ์ได้',
  notfoundsubcatedevice: 'ไม่พบข้อมูลอุปกรณ์ในหมวดหมู่ย่อยนี้',
  getsubcatedevicefailed: 'ไม่สามารถดึงข้อมูลหมวดหมู่ย่อยของอุปกรณ์ได้',
  expenseinfo: 'ข้อมูลค่าใช้จ่าย',
  addexpense: 'เพิ่มค่าใช้จ่าย',
  selectcateexpense: 'เลือกหมวดหมู่ค่าใช้จ่าย',
  expense: 'ค่าใช้จ่ายต่อหน่วย',
  remark: 'หมายเหตุ',
  remarkinput: 'กรอกหมายเหตุ',
  sum: 'รวม',
  totalcost: 'รวมค่าใช้จ่าย',
  spareinfo: 'ข้อมูลรายการอะไหล่',
  spare: 'รายการอะไหล่',
  addlist: 'เพิ่มรายการ',
  list: 'รายการ',
  listinput: 'กรอกรายการ',
  orderbuy: 'ใบสั่งซื้อเลขที่',
  orderbuyinput: 'กรอกเลขที่ใบสั่งซื้อ',
  amount: 'จำนวน',
  amountinput: 'กรอกจำนวน',
  cost: 'ราคา',
  sourcespare: 'ที่มาของอะไหล่',
  sourcespareinput: 'กรอกที่มาของอะไหล่',
  fixdetails: 'รายละเอียดปัญหา',
  fixdetailsinput: 'กรอกรายละเอียดปัญหา',
  reasondetails: 'รายละเอียดสาเหตุ',
  reasondetailsinput: 'กรอกรายละเอียดสาเหตุ',
  solution: 'รายละเอียดวิธีเเก้ไข',
  solutioninput: 'กรอกรายละเอียดวิธีเเก้ไข/ซ่อม',
  admindetails: 'ข้อมูลรายละเอียดหลังบ้าน',
  requesttype: 'ประเภทคำขอ',
  Expectedcompletion: 'วันที่คาดว่าจะเสร็จ',
  fixdone: 'วันที่สำเร็จ',
  expenseSubcateName: 'ค่าใช้จ่ายหมวดหมู่ย่อย',
  expenseCateName: 'ค่าใช้จ่ายหมวดหมู่หลัก',
  change: 'เปลี่ยน',
  fix: 'ซ่อม',
  check: 'ตรวจสอบ',
  orderlist: 'ลำดับ',
  deleteconfirm: 'คุณต้องการลบรายการนี้หรือไม่?',
  searchworkername: 'ค้นหาผู้ดำเนินการซ่อม',
  workername: 'ชื่อผู้ดำเนินการซ่อม',
  confirmfixer: 'ยืนยันการรับงาน',
  confirmdetails: 'คุณแน่ใจหรือไม่ว่าต้องการยืนยันรายการนี้?',
  confirmapprove: 'ยืนยันการอนุมัติ',

  // model fix details
  userinfo: 'ข้อมูลผู้ใช้',
  operatorinfo: 'ข้อมูลการดำเนินการ',
  infodetails: 'ข้อมูลรายละเอียด',
  feedbackinfo: 'ข้อมูลระดับความพึงพอใจ',
  feedback: 'ระดับความพึงพอใจ',
  reason: 'เหตุผล',
  imagefix: 'รูปภาพหลังซ่อม',
  noimage: 'ไม่มีรูปภาพ',
  noimagefix: 'ไม่มีรูปภาพหลังซ่อม',
  talk: 'สนทนา',
  showpdf: 'แสดง PDF',
  improve: 'อนุมัติ',
  showimage: 'ดูรูปภาพ',
  send: 'ส่ง',
  sir: 'คุณ',
  notfoundname: 'ไม่ทราบชื่อ',
  typeing: 'พิมข้อความ...',

  // หน้า navigation bar
  requestsearch: 'รายการแจ้งซ่อม',
  calendar: 'ปฏิทินแจ้งซ่อม',
  calendarView: 'ปฏิทินแจ้งซ่อม',
  updatesearch: 'รายการแจ้งซ่อม',
  adminsearch: 'รายการแจ้งซ่อม',
  usersearch: 'รายการพนักงาน',
  dashboard: 'รายงานผล',
  settings: 'การตั้งค่า',
  userform: 'แก้ไขรายการพนักงาน',
  devicelist: 'แก้ไขรายการอุปกรณ์',
  departmentform: 'แก้ไขรายการแผนก',
  CategoryManagement: 'แก้ไขหมวดหมู่ปัญหา',
  Expense: 'แก้ไขรายการค่าใช้จ่าย',
  deviceCate: 'แก้ไขหมวดหมู่อุปกรณ์',
  location: 'แก้ไขรายการสถานที่',
  jobtitleEdit: 'แก้ไขรายการตำแหน่ง',

  // calendar
  nodetails: 'ไม่มีรายละเอียด',
  start: 'เริ่ม',
  starttime: 'เวลาเรื่มต้น',
  endtime: 'เวลาสิ้นสุด',
  end: 'สิ้นสุด',
  devicename: 'ชื่ออุปกรณ์',
  details: 'รายละเอียด',
  deleteconfirmEvent: 'ยืนยันการลบกิจกรรม',
  title: 'หัวข้อ',
  confirminput: 'กรุณากรอกข้อมูลให้ครบถ้วน',
  adduser: 'เพิ่มสมาชิก',
  edit: 'แก้ไข',
  notfoundlist: 'ไม่พบรายการที่ค้นหา กรุณาลองใหม่อีกครั้ง',
  searchdevice: 'ค้นหาอุปกรณ์',
  pmhistory: 'ข้อมูลประวัติการบำรุงรักษา(PM)',

  // user
  nosignature: 'ไม่มีลายเซ็น',
  active: 'กำลังใช้งาน',
  nonactive: 'ระงับการใช้งาน',
  enable: 'เปิดการใช้งาน',
  nonuser: 'ไม่มีรายการสมาชิก',
  uploadimage: 'อัปโหลดภาพโปรไฟล์',
  drawsignature: 'วาดลายเซ็น',
  clearsignature: 'ล้างลายเซ็น',
  update: 'อัพเดท',
  newadd: 'เพื่มใหม่',
  userlist: 'รายการพนักงาน',
  employeeinfo: 'ข้อมูลพนักงาน',
  fullname: 'ชื่อ-นามสกุล',
  signature: 'ลายเซ็น',
  nonuserdetails: 'ไม่พบข้อมูลพนักงาน',
  youwant: 'คุณต้องการ',
  yesorno: 'ใช่หรือไม่',

  // dashboard
  all: 'ทั้งหมด',
  year: 'ปี',
  month: 'เดือน',
  day: 'วัน',
  fixrequest: 'การแจ้งซ่อม',
  totalall: 'รวมจำนวนทั้งหมด',
  totalcostall: 'รวมค่าใช้จ่ายทั้งหมด',
  fixrequeststatus: 'สถานะการแจ้งซ่อม',
  expensefix: 'ค่าใช้จ่ายแจ้งซ่อม',
  bath: 'บาท',
  sparecost: 'ค่าใช้จ่ายอะไหล่',
  alluser: 'ผู้ใช้งานทั้งหมด',
  person: 'คน',
  devicestatuslist: 'รายการสถานะอุปกรณ์',
  alldevice: 'อุปกรณ์ทั้งหมด',
  pmlist: 'รายการจำนวนอุปกรณ์(PM)',
  nodata: 'ไม่มีข้อมูล',
  repairCount: 'จำนวนการซ่อม',
  fixcostdevice: 'ค่าใช้จ่ายซ่อมตามอุปกรณ์',
  fixcost: 'ค่าใช้จ่ายซ่อม',
  sparecostdevice: 'ค่าใช้จ่ายอะไหล่ตามอุปกรณ์',
  employeerole: 'จำนวนพนักงานตามสิทธิ์ผู้ใช้',
  pmamount: 'จำนวนอุปกรณ์ที่PM',
  getdevice: 'วันที่รับ',
  fixworker: 'รายการจำนวนงานช่าง',
  repairstatusCount: 'จำนวนสถานะการซ่อม',
  fixstatusworker: 'รายการจำนวนสถานะงานช่าง',
  costdevice: 'จำนวนอุปกรณ์',
  statusfix: 'รายการประเภทคำขอ',
  pmcount: 'จำนวนในการPM',
  times: 'ครั้ง',
  dateselect: 'กรุณาเลือกวันที่ให้ถูกต้อง',
  searchtitlename: 'ค้นหาหัวข้อ',
  titlename: 'หัวข้อ',

  // deivce
  adddevice: 'เพิ่มอุปกรณ์',
  selectsearchtype: 'เลือกประเภทการค้นหา',
  nondevice: 'ไม่มีรายการอุปกรณ์',
  sndevice: 'หมายเลขอุปกรณ์',
  model: 'รุ่น',
  locationname: 'สถานที่',
  searchsndevice: 'ค้นหาหมายเลขอุปกรณ์',
  searchnamedevice: 'ค้นหาชื่ออุปกรณ์',
  searchmodel: 'ค้นหาชื่ออุปกรณ์',
  searchcate: 'ค้นหาหมวดหมู่',
  searchsubcate: 'ค้นหาหมวดหมู่ย่อย',
  searchuser: 'ค้นหาผู้ใช้',
  searchdepartment: 'ค้นหาแผนก',
  searchlocation: 'ค้นหาสถานที่',
  searchcost: 'ค้นหาราคา',
  searchstatus: 'ค้นหาสถานะ',
  catedevice: 'หมวดอุปกรณ์หลัก',
  subcatedevice: 'หมวดอุปกรณ์ย่อย',
  warrantydetails: 'ข้อมูลการรับประกัน',
  warrantydetail: 'ข้อมูลประกัน',
  providerName: 'ชื่อผู้ให้บริการ',
  warrantytime: 'ระยะเวลา (ปี, เดือน, วัน)',
  expdate: 'วันที่หมดอายุ',
  nodatawarranty: 'ไม่มีข้อมูลการรับประกัน',
  nowarranty: 'ไม่มีประกัน',
  hardwaredetails: 'ข้อมูลอุปกรณ์ฮาร์ดแวร์',
  detailsinput: 'กรอกรายละเอียด',
  nodetailshardware: 'ไม่มีข้อมูลอุปกรณ์ฮาร์ดแวร์',
  devicestatus: 'สถานะอุปกรณ์',
  assetType: 'ประเภทสินทรัพย์',
  otherdetails: 'ข้อมูลเพื่มเติม',
  detailsanother: 'รายละเอียดเพื่มเติม',
  detailsanotherinput: 'กรอกรายละเอียดเพื่มเติม',
  edituserdevice: 'แก้ไขผู้ใช้งานอุปกรณ์',
  zeroyear: '0 ปี',
  zeromonth: '0 เดือน',
  zeroday: '0 วัน',
  use: 'ใช้งาน',
  nonuse: 'เลิกใช้งาน',
  sellscrap: 'ขายเศษซาก',
  rent: 'เช่าใช้งาน',
  buy: 'ซื้อขาด',
  vendor: 'ชื่อผู้ให้บริการ',
  warrantyday: 'ระยะเวลา (วัน)',
  warrantyExp: 'วันที่หมดอายุ',
  exp: 'หมดอายุแล้ว',
  after: 'เหลืออีก ',
  hour: 'ชั่วโมง',
  inday: 'ภายในวันนี้',
  confirmdelete: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?',
  deviceinfodetails: 'รายละเอียดอุปกรณ์',
  warrantydevice: 'ข้อมูลประกันอุปกรณ์',
  fixhistory: 'ข้อมูลประวัติการซ่อม',
  userdevicehistory: 'ข้อมูลประวัติผู้ใช้อุปกรณ์',
  nondevicedetails: 'ไม่มีข้อมูลประวัติอุปกรณ์',
  outofdate: 'วันที่เลิกใช้งาน',
  startuse: 'เริ่มใช้งาน',
  enduse: 'เลิกใช้งาน',
  delconfirm: 'ยืนยันการลบ',
  yes: 'ใช่',
  enterdevice: 'กรุณาเลือกอุปกรณ์',
  entersubdevice: 'กรุณาเลือกหมวดหมู่อุปกรณ์',

  // department
  deptid: 'รหัสแผนก',
  adddept: 'เพิ่มแผนก',
  editdept: 'แก้ไขแผนก',
  nodeptdetails: 'ไม่มีรายการแผนก',

  // cate
  editlist: 'แก้ไขรายการ',
  addcate: 'เพื่มหมวดหมู่',
  catename: 'ชื่อหมวดหมู่',
  subcatename: 'ชื่อหมวดหมู่ย่อย',
  add: 'เพื่ม',
  editsubcate: 'แก้ไขหมวดหมู่ย่อย',
  addsubcate: 'เพื่มหมวดหมู่ย่อย',
  reset: 'รีเซ็ท',
  searchcateAndsubname: 'ค้นหาหมวดหมู่หลัก/ย่อย',

  // location
  searchlocationname: 'ชื่อสถานที่',
  addlocation: 'เพิ่มสถานที่',
  editlocation: 'แก้ไขสถานที่',
  nolocationlist: 'ไม่มีรายการสถานที่',

  // jobtitle
  jobtitlename: 'ชื่อตำแหน่ง',
  addjobtitle: 'เพิ่มตำแหน่ง',
  selectdept: 'เลือกแผนก',
  editjobtitle: 'แก้ไขตำแหน่ง',
  nojobtitlelist: 'ไม่มีรายการตำเเหน่ง',

  // อื่นๆ
  notfoundsearch: 'ไม่พบข้อมูลที่ค้นหา',
  pmdevice: 'บำรุงรักษาอุปกรณ์',
  time: 'ระยะเวลา',
  today: 'วันนี้',
  datailsanother: 'รายละเอียดอื่นๆ',
  useddelete: 'รายการนี้กำลังถูกใช้งานอยู่ไม่สามารถลบได้',
  confirmapproveall: 'ยืนยันการอนุมัติทั้งหมด',
  confirmapprovealldetails: 'คุณแน่ใจหรือไม่ว่าต้องการอนุมัติทุกรายการแจ้งซ่อม?',
  Profile: 'โปรไฟล์',
  logout: 'ออกจากระบบ',
  other: 'อื่นๆ',

  // error page
  pagenotfound: 'ไม่พบหน้าที่คุณต้องการเข้าถึง',
  pagenotfounddetails: 'โอ๊ะ! ไม่พบ URL ที่คุณร้องขอบนเซิร์ฟเวอร์นี้',
  backhome: 'กลับหน้าหลัก',

  delete: 'ลบ',
  Collapse: 'ย่อ',
  Expand: 'ขยาย',
  getjob: 'รับงาน',
  phoneinput: 'กรอกเบอร์โทร/เบอร์ภายใน',
  resetpassword: 'รีเซ็ทรหัสผ่าน',
  passwordold: 'รหัสผ่านเก่า',
  passwordnew: 'รหัสผ่านใหม่',
  passwordconfirm: 'ยืนยันรหัสผ่านใหม่',
  passwordUpdateSuccess: 'อัปเดตข้อมูลสำเร็จ !!',
  success: 'สำเร็จ',
  headcheck: 'รออนุมัติลายเซ็น',

  quantity: 'จำนวน',
  unit: 'หน่วย',
  sn: 'หมายเลขอุปกรณ์',
  sninput: 'กรอกหมายเลขอุปกรณ์',
  searchsn: 'ค้นหาหมายเลขอุปกรณ์',
}
